export default {
  preTitle: 'Message',
  title: 'Send message'
}